var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_container"},[_c('div',{staticClass:"mailbox_text"},[_vm._v(_vm._s(_vm.marketingConsentMessage))]),_c('div',{staticClass:"img_box"},[_c('img',{staticClass:"logo_img",attrs:{"src":_vm.imgSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }